import * as yup from 'yup';

export const paymentSettingsSchema = yup.object().shape({
  buttonLabel: yup.string().optional(),
  currency: yup.string().required('Currency is required'),
  amountColumn: yup.string().required('Amount column is required'),
  statusColumnId: yup.string().required('Payment status column is required'),
  statusColumnLabel: yup.string().required('Payment status label is required'),
  transactionIdColumnId: yup
    .string()
    .required('Payment transaction column is required'),
  isPaymentReminderEnabled: yup.boolean().default(false),
  remindAfter: yup.number().when('isPaymentReminderEnabled', {
    is: true,
    then: (schema) => schema.required('Number of days is required.'),
    otherwise: (schema) => schema.optional(),
  }),
});

export type PaymentSettingsFormData = yup.InferType<
  typeof paymentSettingsSchema
>;

